import { Component, ChangeDetectionStrategy } from '@angular/core';

/** YouTube Shorts logo (red mark with a white play triangle); sized by the host. */
@Component({
    selector: 'app-youtube-shorts-logo',
    template: `
      <svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true">
        <path
          fill="#f03"
          d="m18.931 9.99-1.441-.601 1.717-.913a4.48 4.48 0 0 0 1.874-6.078 4.506 4.506 0 0 0-6.09-1.874L4.792 5.929a4.504 4.504 0 0 0-2.402 4.193 4.521 4.521 0 0 0 2.666 3.904c.036.012 1.442.6 1.442.6l-1.706.901a4.51 4.51 0 0 0-2.369 3.967A4.528 4.528 0 0 0 6.93 24c.725 0 1.437-.174 2.08-.508l10.21-5.406a4.494 4.494 0 0 0 2.39-4.192 4.525 4.525 0 0 0-2.678-3.904Z"
        />
        <path fill="#fff" d="M9.597 15.19V8.824l6.007 3.184z" />
      </svg>
    `,
    styles: [':host { display: block; } svg { display: block; }'],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class YoutubeShortsLogoComponent {}
